import React, { useEffect } from "react";
import { Box, Grid, Typography, Link, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YoutubeIcon from "@mui/icons-material/YouTube";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import placeholderLogo from "../assets/images/DSH LOGOS.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#f9f9f9",
        padding: "32px 32px",
        marginTop: "50px",
        boxShadow: "0 0 5px 1px",
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} md={3} data-aos="zoom-in">
          <img
            src={placeholderLogo}
            alt="logo"
            style={{ height: "150px", marginLeft: 40 }}
          />
          <Box
            sx={{
              display: "flex",
              color: "black",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#007ca0" }}
            >
              Doctor Service AT Home
            </Typography>
          </Box>
          {/* <Typography variant="body2" sx={{ color: "black", lineHeight: 1.8 }}>
            Providing top-notch medical care right at your doorstep. Our
            dedicated team of licensed professionals ensures quality healthcare
            in the comfort of your home. 
          </Typography> */}
        </Grid>

        {/* <Grid md={1}></Grid> */}

        <Grid item xs={12} md={3} data-aos="zoom-in">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            Quick Links
          </Typography>
          <Box>
            <Link
              href="#"
              underline="none"
              sx={{
                display: "block",
                color: "black",
                marginBottom: 1,
              }}
            >
              Home
            </Link>
            <Link
              href="/about"
              underline="none"
              sx={{
                display: "block",
                color: "black",
                marginBottom: 1,
              }}
            >
              About Us
            </Link>

            <Link
              href="/contact"
              underline="none"
              sx={{
                display: "block",
                color: "black",
                marginBottom: 1,
              }}
            >
              Contact Us
            </Link>

            <Link
              href="/gallery"
              underline="none"
              sx={{
                display: "block",
                color: "black",
                marginBottom: 1,
              }}
            >
              Gallery
            </Link>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} data-aos="zoom-in">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            Contact Us
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" gap={1}>
              <LocationOnIcon sx={{ color: "black" }} />
              <Typography variant="body2" sx={{ color: "black" }}>
                D-57, Sachin Tendulkar Rd, near Farm Fresh Shop, New Govindpuri,
                Mahalgaon, Gwalior, Madhya Pradesh 474011
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <PhoneIcon sx={{ color: "black" }} />
              <Typography variant="body2" sx={{ color: "black" }}>
                +91 9243742790
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <EmailIcon sx={{ color: "black" }} />
              <Typography variant="body2" sx={{ color: "black" }}>
                info@doctorserviceathome.com
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} data-aos="zoom-in">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            Follow Us
          </Typography>
          <Box display="flex" gap={2}>
            <IconButton
              href="https://www.instagram.com/doctor_service_at_home25?igsh=ZGUzMzM3NWJiOQ=="
              target="_blank"
              sx={{ color: "black" }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              href="https://facebook.com"
              target="_blank"
              sx={{ color: "black" }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              href="https://twitter.com"
              target="_blank"
              sx={{ color: "black" }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              href="https://youtube.com"
              target="_blank"
              sx={{ color: "black" }}
            >
              <YoutubeIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box
        sx={{
          borderTop: "1px solid grey",
          marginTop: 4,
          paddingTop: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "black",
            fontWeight: "bold",
            marginTop: 1,
            fontSize: 18,
          }}
        >
          &copy; 2025 Doctor Service AT Home. All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
